// src/redux-saga/sagas/testCaseSaga.js

import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_TESTCASES_REQUEST,
  CREATE_TESTCASE_REQUEST,
  UPDATE_TESTCASE_REQUEST,
  DELETE_TESTCASE_REQUEST,
  GENERATE_TESTCASE_REQUEST,
  PROCESS_TESTCASE_REQUEST,
  fetchTestCasesSuccess,
  fetchTestCasesFailure,
  createTestCaseSuccess,
  createTestCaseFailure,
  updateTestCaseSuccess,
  updateTestCaseFailure,
  deleteTestCaseSuccess,
  deleteTestCaseFailure,
  generateTestCaseSuccess,
  generateTestCaseFailure,
  processTestCaseSuccess,
  processTestCaseFailure,
  fetchTestCasesRequest,
  setProcessModalData,


} from '../actions/testCaseAction';
import { notification } from 'antd';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = `${getBaseUrl()}/api/testcases`;
const getAuthToken = () => localStorage.getItem('authToken');

function* fetchTestCasesSaga(action) {
  try {
    const token = getAuthToken();
    const { page = 1, limit = 10, search = '' } = action.payload || {};
    const response = yield call(axios.get, API_BASE_URL, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit, search },
    });
    yield put(fetchTestCasesSuccess(response.data));
  } catch (error) {
    yield put(fetchTestCasesFailure(error.message));
  }
}

function* createTestCaseSaga(action) {
  try {
    const token = getAuthToken();
    const { data, meta } = action.payload;
    const response = yield call(axios.post, API_BASE_URL, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(createTestCaseSuccess(response.data));
    yield put(fetchTestCasesRequest(meta));
  } catch (error) {
    yield put(createTestCaseFailure(error.message));
  }
}


function* updateTestCaseSaga(action) {
  const { testCaseId, testCaseData, meta } = action.payload;
  try {
    const token = getAuthToken();
    const response = yield call(axios.put, `${API_BASE_URL}/${testCaseId}`, testCaseData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(updateTestCaseSuccess(response.data));
    yield put(fetchTestCasesRequest(meta));
  } catch (error) {
    yield put(updateTestCaseFailure(error.message));
  }
}

function* deleteTestCaseSaga(action) {
  const { testCaseId, meta } = action.payload;
  try {
    const token = getAuthToken();
    yield call(axios.delete, `${API_BASE_URL}/${testCaseId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    yield put(deleteTestCaseSuccess(testCaseId));
    yield put(fetchTestCasesRequest(meta));
  } catch (error) {
    yield put(deleteTestCaseFailure(error.message));
  }
}

function* generateTestCaseSaga(action) {
  try {
    const token = getAuthToken();
    const response = yield call(axios.post, `${API_BASE_URL}/generate/${action.payload.agentId}`,{extraInfo:action.payload.extraInfo},{
        headers: { Authorization: `Bearer ${token}` },
      });
    if (response) {
      yield put(generateTestCaseSuccess(response.data));
      const  count = response.data?.count || 0
      console.log(count, "count")
      notification.success({
        key: "test_case_generation", 
        message: 'Test Case Generated',
        description:`Sucessfully ${count} test cases generated`
      });
    } else {
      throw new Error(response.data?.message || "Failed to generate test cases");
    }
  } catch (error) {
    yield put(generateTestCaseFailure(error.message));
    notification.error({
      key: "test_case_generation",
      message: "Test Case Generation Failed",
      description: error.message || "Something went wrong while generating test cases.",
    });
  }
}

function* processTestCaseSaga(action) {
  try {
    const token = getAuthToken();
    const { agentId, modelName } = action.payload;

    const response = yield call(
      axios.post,
      `${API_BASE_URL}/process/${agentId}?model=${modelName}`,
      {extraInfo:action.payload.extraInfo},
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (response) {
      yield put(processTestCaseSuccess(response.data));

      const results = response.data?.data || [];
      const trueCount = results.filter((item) => item.result == true).length;
      const notFoundCases = results.filter((item) => item.result === 'not found');
      const failedCases = results.filter((item) => item.result != true);
      console.log(results, trueCount, notFoundCases, failedCases)
      yield put(setProcessModalData({
        open: true,
        passed: trueCount,
        failed: results.length - trueCount - notFoundCases.length,
        undetermined: notFoundCases.length,
        failedCases: failedCases,
      }));
    } else {
      throw new Error(response.data?.message || 'Failed to process test cases');
    }
  } catch (error) {
    yield put(processTestCaseFailure(error.message));
    yield put(setProcessModalData({
      open: true,
      error: error.message || 'Something went wrong while processing test cases.',
      passed: 0,
      failed: 0,
      undetermined: 0,
      failedCases: [],
    }));
  }
}

export default function* testCaseSaga() {
  yield takeLatest(FETCH_TESTCASES_REQUEST, fetchTestCasesSaga);
  yield takeLatest(CREATE_TESTCASE_REQUEST, createTestCaseSaga);
  yield takeLatest(UPDATE_TESTCASE_REQUEST, updateTestCaseSaga);
  yield takeLatest(DELETE_TESTCASE_REQUEST, deleteTestCaseSaga);
  yield takeLatest(GENERATE_TESTCASE_REQUEST, generateTestCaseSaga);
  yield takeLatest(PROCESS_TESTCASE_REQUEST, processTestCaseSaga);
}
